import ProductCompletionService, {
  AutoCompleteResponse,
} from '@/services/product/completion/ProductCompletionService';
import {
  ProductCompletionRequest,
  SubshopProductSearchApi,
} from '@eurogast/hub-client-typescript';
import { ApiService } from '@/services/ApiService';
import { ConfigService } from '@/services/ConfigService';

export default class FairProductCompletionService implements ProductCompletionService {
  private static productSearchApi: SubshopProductSearchApi;

  private static getApi(): SubshopProductSearchApi {
    if (!this.productSearchApi) {
      this.productSearchApi = ApiService.wrap(SubshopProductSearchApi);
    }

    return this.productSearchApi;
  }

  private cartType: string;

  public constructor(cartType: string) {
    this.cartType = cartType;
  }

  public async completeProducts(
    completionBody: ProductCompletionRequest
  ): Promise<AutoCompleteResponse> {
    const apiResponse =
      await FairProductCompletionService.getApi().completeCustomerProductName(
        ConfigService.getTenant(),
        ConfigService.currentCustomerId,
        this.cartType,
        completionBody
      );

    return AutoCompleteResponse.fromSubshopResponse(apiResponse);
  }
}
